import React from 'react';
import { Divider } from 'antd';

import './index.less';

export default ({ title, className, ...rest }) => {
  const cls = `sale-title ${className || ''}`;
  return (
    <div className={cls} {...rest}>
      <Divider className="long" />
      <Divider className="short" />
      <span className="title-name">{title}</span>
      <Divider className="short" />
      <Divider className="long" />
    </div>
  );
};
